import { classConstants } from '../constants';
import { classService } from '../services';
import { showToast } from '../services/toast';

export const classActions = {
  fetchClasses,
  createClass,
  updateClass,
  deleteClass,
  clearChathistory,
  activateClass
};

function fetchClasses() {
  return dispatch => {
    dispatch(request());

    classService.getClassList()
      .then(
        response => {
          dispatch(success(response.data));
        },
        error => {
          dispatch(failure(error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: classConstants.FETCH_CLASSES_REQUEST } }
  function success(classes) { return { type: classConstants.FETCH_CLASSES_SUCCESS, classes } }
  function failure(error) { return { type: classConstants.FETCH_CLASSES_FAILURE, error } }
}

function createClass(classDetails) {
  return dispatch => {
    dispatch(request());

    return classService.createClass(classDetails)
      .then(
        response => {
          dispatch(success(response));
          showToast(response.responseMessage, 'success');
          return response;
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: classConstants.CREATE_CLASS_REQUEST } }
  function success(classes) { return { type: classConstants.CREATE_CLASS_SUCCESS, classes } }
  function failure(error) { return { type: classConstants.CREATE_CLASS_FAILURE, error } }
}


function updateClass(classDetails) {

  return dispatch => {
    dispatch(request());
    classService.updateClass(classDetails)
      .then(
        classes => {
          // dispatch(success(classes));
          showToast(classes.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: classConstants.UPDATE_CLASS_REQUEST } }
  function success(classes) { return { type: classConstants.UPDATE_CLASS_SUCCESS, classes } }
  function failure(error) { return { type: classConstants.UPDATE_CLASS_FAILURE, error } }

}


function deleteClass(classId) {

  return dispatch => {
    dispatch(request());
    classService.deleteClass(classId)
      .then(
        (res) => {
          dispatch(success(classId));
          showToast(res.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: classConstants.DELETE_CLASS_REQUEST } }
  function success(id) { return { type: classConstants.DELETE_CLASS_SUCCESS, payload: id } }
  function failure(error) { return { type: classConstants.DELETE_CLASS_FAILURE, error } }
}


function clearChathistory(submissionData) {
  return dispatch => {
    dispatch(request());

    classService.clearChathistory(submissionData)
      .then(
        response => {
          dispatch(success(submissionData));
          showToast(response.responseMessage, 'success');
        },
        error => {
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: classConstants.CLEAR_CHATHISTORY_REQUEST } }
  function success(data) { return { type: classConstants.CLEAR_CHATHISTORY_SUCCESS, data } }
  function failure(error) { return { type: classConstants.CLEAR_CHATHISTORY_FAILURE, error } }

}

function activateClass(classDetails) {

  return dispatch => {
    dispatch(request());
    classService.activateClass(classDetails)
      .then(
        response => {
          dispatch(success(classDetails));
          showToast(response.responseMessage, 'success');
        },
        error => {
          dispatch(failure(error));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

  function request() { return { type: classConstants.ACTIVATE_CLASS_REQUEST } }
  function success(classes) { return { type: classConstants.ACTIVATE_CLASS_SUCCESS, classes } }
  function failure(error) { return { type: classConstants.ACTIVATE_CLASS_FAILURE, error } }

}
